import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import BackButton from "../../Components/BackButton";
import CustomButton from "../../Components/CustomButton";
import CustomInput from "../../Components/CustomInput";
import { SelectBox } from "../../Components/CustomSelect";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import { useAddBannerMutation } from "../../Redux/Apis/Banner";
import { useUploadImageMutation } from "../../Redux/Apis/General";
import { objectValidator } from "../../Utils";

const AddBanner = () => {

    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Landing List | Add Brand';
    }, []);

    const [add, { isLoading, isSuccess, data }] = useAddBannerMutation();
    const [upload, { isLoading: uploadingImage }] = useUploadImageMutation();

    const [type, setType] = useState("")
    const [url, setUrl] = useState("")
    const [image, setImage] = useState("")

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message)
            navigate('/banner')
        }
    }, [isSuccess]);

    const onClickSave = () => {

        let validate = objectValidator({ type, image })

        if (validate) {

            let form = new FormData()
            form.append('image', image)

            upload(form).then(res => {
                if (res && res.data) {
                    add({
                        type,
                        redirection: url,
                        image: res.data.path
                    })
                }
            }).catch(err => {
                console.log("Error while uploading image", err)
            })

        }
    }

    return (
        <>
            <DashboardLayout>
                <div className="dashCard mb-4">
                    <div className="row mb-3">
                        <div className="col-12">
                            <h2 className="mainTitle">
                                <BackButton />
                                Add New Banner
                            </h2>
                        </div>
                    </div>
                    <div className="d-flex mb-3">
                        {
                            image && <img className="mx-2" src={URL.createObjectURL(image)} style={{ width: '200px', height: '200px', objectFit: 'contain', borderRadius: 12, backgroundColor: '#F0F0F0' }} />
                        }
                    </div>
                    <div className="row mb-3">
                        <div className="col-4">
                            <CustomInput
                                label="Banner Image"
                                labelClass="mainLabel"
                                required
                                type="file"
                                placeholder="Enter Redirection Url"
                                inputClass="mainInput"
                                value={image?.filename}
                                onChange={(e) => setImage(e.target.files[0])}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-4">
                            <SelectBox
                                label="Select Type"
                                labelClass="mainLabel"
                                selectClass="mainInput"
                                name="Type"
                                required
                                option={[{ label: "Home", value: 'Home' }, { label: "Special", value: 'Specials' }]}
                                value={type}
                                onChange={e => setType(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-4">
                            <CustomInput
                                label="Banner Redirection Url"
                                labelClass="mainLabel"
                                required
                                placeholder="Enter Redirection Url"
                                inputClass="mainInput"
                                value={url}
                                onChange={e => setUrl(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-4">
                            <CustomButton
                                text="Save"
                                onClick={onClickSave}
                                loading={uploadingImage || isLoading}
                            />
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </>
    );
};

export default AddBanner;